import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as actions from '../../../../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as textUtil from "../../../../../utils/textUtil.js";
import { isMessageStreamingSelector } from '../../../../../reducers/selector.js';

function CustomButton({ button, buttonType, clickButton, textAlign, style = {}, isStreamingMessage }) {
  const buttonClass = classNames(
    'cu-ui-button',
    {
      'cu-ui-button-base': buttonType !== 'carousel'
    },
    {
      'cu-ui-secondary': buttonType === 'carousel' || buttonType === 'footer'
    },
    {
      'cu-ui-intent-keyword': buttonType === 'footer'
    },
    {
      'cu-ui-block': buttonType === 'wide' || buttonType === 'carousel'
    },
    {
      'cu-ui-button-lg': buttonType === 'footer'
    },
    {
      [`cu-ui-text-align-${textAlign}`]: buttonType === 'wide' && !!textAlign
    }
  );

  const modifiedText = textUtil.prepareTextForRender(button.text);

  return (
    <button
      className={buttonClass}
      onClick={() => {
        clickButton(button);
      }}
      style={style}
      disabled={isStreamingMessage}
      dangerouslySetInnerHTML={buttonType === 'footer' ? undefined : { __html: modifiedText }}
      children={buttonType === 'footer' ? <span dangerouslySetInnerHTML={{ __html: modifiedText }} /> : undefined}
    />
  );
};

CustomButton.propTypes = {
  button: PropTypes.object,
  buttonType: PropTypes.string,
  clickButton: PropTypes.func,
  textAlign: PropTypes.oneOf(['left', 'right', '']),
};

const mapStateToProps = (state) => {
  return {
    isStreamingMessage: isMessageStreamingSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clickButton: bindActionCreators(actions.clickOnButton, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomButton);
